module.exports = __webpack_public_path__ + "img/money-check-dollar-pen.4f6fb5af.svg";